import React, { PureComponent } from 'react';
import { Flex } from 'app/components/common/Flex';
import { Divider, Input, notification } from 'antd';
import InputTime from 'app/common/input/InputTime';
import { ModalPanelProps } from 'app/components/panels/DashboardModal';
import {
    DatasetDto,
    FLIGHT_DETAILS_REQUEST_DTO_CLAZZ_VALUE,
    FlightDataset,
    FlightDetailsRequestDto,
    FlightExchangeModelType,
    FlightId,
    OpLogEntry,
    StandardFlightFieldType,
} from 'app/model/CORE';
import OpLogEntryTable, { STANDARD_OP_LOG_ENTRY_COLUMN_LIST } from 'app/components/table/OpLogEntryTable';
import { ServiceFactory } from 'app/service/ServiceFactory';
import './FlightOpLogPanel.less';
import memoizeOne from 'memoize-one';
import { SINGLE_SELECTION, SingleSelection } from 'app/common/table/ManagedTable';
import AutoSizer from 'react-virtualized-auto-sizer';
import ConditionalRender from 'app/common/components/ConditionalRender';
import Utils from 'app/common/util/Utils';

export interface FlightOpLogPanelProps extends ModalPanelProps {
    id: FlightId;
    dataset: DatasetDto;
}

const INITIAL_STATE: FlightOpLogPanelState = {
    data: [],
    loading: false,
};

export interface FlightOpLogPanelState {
    data: Array<OpLogEntry>;
    selection?: OpLogEntry;
    loading: boolean;
}

export default class FlightOpLogPanel extends PureComponent<FlightOpLogPanelProps, FlightOpLogPanelState> {
    public static INITIAL_WIDTH = '70em';

    constructor(props) {
        super(props);
        this.state = INITIAL_STATE;
    }

    private tableSelection = memoizeOne(
        (selection): SingleSelection<OpLogEntry> => ({
            selectionMode: SINGLE_SELECTION,
            onSelectionChange: this.onTableSelection,
            selectedItem: selection,
        }),
    );

    componentDidMount() {
        const request: FlightDetailsRequestDto = {
            clazz: FLIGHT_DETAILS_REQUEST_DTO_CLAZZ_VALUE,
            dataset: this.props.dataset,
            proposalContexts: null,
            flightId: this.props.id,
            flightDatasets: [FlightDataset.FLIGHT],
            flightFields: [StandardFlightFieldType.OPLOG],
            requestedDataFormat: FlightExchangeModelType.NM_B2B,
            maxWindowForRegulationRiskInMs: -1,
        };
        this.setState({ loading: true });
        ServiceFactory.coreService()
            .getFlightData(request)
            .then(reply => {
                if (reply.error) {
                    notification.error({ message: 'Error', description: reply.error.message, duration: 0 });
                } else {
                    this.setState({ data: reply.data?.flight?.opLogHistory });
                }
            })
            .catch(reason => {
                notification.error({ message: 'Error', description: reason.message, duration: 0 });
            })
            .finally(() => this.setState({ loading: false }));
    }

    render() {
        return (
            <Flex direction="vertical" className="flight-oplog-panel overflow">
                {this.renderHeader()}
                {this.renderContent()}
            </Flex>
        );
    }

    renderHeader() {
        return (
            <Flex size="2em" className="modal-title header" grow={false} shrink={false}>
                <Flex className="detailed-subpanel-header-left">
                    <div style={{ height: '1em', alignSelf: 'center' }}>
                        <span className="detailed-subpanel-title">FLIGHT OPLOG</span>
                        <span className="detailed-subpanel-title-info">{this.props.id?.flightKeys?.callsign}</span>
                    </div>
                </Flex>
                <Flex className="detailed-subpanel-header-right" style={{ paddingRight: '1.5em' }}>
                    <span>
                        ADEP
                        <Input style={{ width: '5em' }} disabled={true} value={this.props.id?.flightKeys?.adep} />
                    </span>
                    <span>
                        ADES
                        <Input style={{ width: '5em' }} disabled={true} value={this.props.id?.flightKeys?.ades} />
                    </span>
                    <span>
                        IOBT
                        <InputTime style={{ width: '5em' }} value={this.props.id?.flightKeys?.eobt} disabled={true} />
                    </span>
                </Flex>
            </Flex>
        );
    }

    renderContent() {
        return (
            <Flex direction="vertical" grow={false} shrink={false} style={{ padding: '1em' }}>
                <Flex size="15em">
                    <OpLogEntryTable
                        data={this.state.data}
                        columns={STANDARD_OP_LOG_ENTRY_COLUMN_LIST}
                        selection={this.tableSelection(this.state.selection)}
                        loading={this.state.loading}
                    />
                </Flex>
                <Divider type="horizontal" />
                <Flex size="15em">{this.renderOpLogMessageResize()}</Flex>
            </Flex>
        );
    }

    renderOpLogMessageResize() {
        return (
            <AutoSizer>
                {({ height, width }) => (
                    <div className="oplog-message" style={{ height: height, width: width }}>
                        {this.state.selection && this.state.selection.message}
                        <ConditionalRender condition={Utils.isNotExists(this.state.selection)}>
                            <div style={{ display: 'flex', justifyContent: 'center', margin: '1em' }}>
                                EMPTY SELECTION
                            </div>
                        </ConditionalRender>
                    </div>
                )}
            </AutoSizer>
        );
    }

    //handlers
    onTableSelection = (selection: OpLogEntry) => {
        this.setState({ selection: selection });
    };
}
